"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartTokens = void 0;
var _dark = require("./dark");
var _light = require("./light");
/**
 * Telemetry chart styling per mode (consumed by the web Recharts theme and,
 * later, the shared SVG chart components).
 *
 * The tooltip stays a dark floating chip in BOTH modes — it overlays
 * arbitrary chart content, and the near-black treatment reads everywhere.
 *
 * Stroke widths: Recharts renders slightly thinner than react-native-svg at
 * the same numeric width, so web uses these bumped values for visual parity
 * with mobile's 2.5/2.
 */
const chartTokens = exports.chartTokens = {
  dark: {
    gridStroke: 'rgba(255, 255, 255, 0.12)',
    axisStroke: 'rgba(255, 255, 255, 0.45)',
    axisLabel: _dark.darkPalette.text,
    tooltipBg: 'rgba(0, 0, 0, 0.85)',
    tooltipBorder: 'rgba(255, 255, 255, 0.08)',
    tooltipText: '#FFFFFF',
    tooltipLabel: 'rgba(255, 255, 255, 0.6)',
    lineStrokeWidth: 3,
    lineStrokeWidthSecondary: 2
  },
  light: {
    gridStroke: 'rgba(11, 22, 35, 0.10)',
    axisStroke: 'rgba(11, 22, 35, 0.45)',
    axisLabel: _light.lightPalette.text,
    tooltipBg: 'rgba(11, 22, 35, 0.88)',
    tooltipBorder: 'rgba(255, 255, 255, 0.08)',
    tooltipText: '#FFFFFF',
    tooltipLabel: 'rgba(255, 255, 255, 0.6)',
    lineStrokeWidth: 3,
    lineStrokeWidthSecondary: 2
  }
};